var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgJobox = function SvgJobox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.98 0h10.849c.333 0 .602.333.602.744v7.814c0 .411-.27.744-.602.744H.979c-.332 0-.602-.333-.602-.744V.744C.377.334.647 0 .979 0zM.752 10.79h11.302c.208 0 .377.209.377.466v.93c0 .257-.17.465-.377.465H.753c-.208 0-.376-.208-.376-.465v-.93c0-.257.168-.465.376-.465zm0 3.35h11.302c.208 0 .377.208.377.465v.93c0 .257-.17.465-.377.465H.753c-.208 0-.376-.208-.376-.465v-.93c0-.257.168-.466.376-.466z",
    fill: "#0075FF"
  })));
};

export default SvgJobox;